import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import DashboardLayout from "../layout/DashboardLayout";
import Folder from "../components/Dashboard/Folder";
import Students from "../components/Dashboard/Students";
import Authanticated from "./AuthanticatedRoutes";
import NotFound from "../components/NotFound";
import Cart from "../components/Dashboard/Cart";
import UserDetails from "../components/Dashboard/UserDetails";
import Coupon from "../components/Dashboard/Coupon";

interface AuthRoutesProps {
  // define props here
}

const DashboardRoute: React.FC<AuthRoutesProps> = (props) => {
  const [refresh, setIsRefresh] = useState(false);
  return (
    <Authanticated>
      <DashboardLayout setIsRefresh={setIsRefresh}>
        <Routes>
          <Route path="/" element={<Folder refresh={refresh} />} />
          <Route path="/:folderId" element={<Folder refresh={refresh} />} />
          <Route path="/students" element={<Students />} />
          <Route path="/cart/:courseId" element={<Cart />} />
          <Route path="/user-data" element={<UserDetails />} />
          <Route path="/coupons" element={<Coupon />} />
          {/* <Route path="/*" element={<NotFound />} /> */}
        </Routes>
      </DashboardLayout>
    </Authanticated>
  );
};

export default DashboardRoute;
